export default {
  nav: {
    back: {
      en: 'Back',
      fr: 'Retour',
      nl: 'Terug'
    },
  }
}